import React from "react";
import cx from "clsx";
import Tooltip from "../Tooltip";

const IconButton = ({
  icon,
  borderColor,
  fromColor,
  toColor,
  onClick,
  tooltipText,
  tooltipPlace = "right",
  buttonStyle = { padding: "3.3px" },
  text = null,
  ...props
}) => {
  const button = (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick(e);
      }}
      className={cx(
        text !== null ? `w-15 h-5` : `size-5`,
        "rounded-[5px] flex justify-center items-center",
        text !== null && "text-sm"
      )}
      style={{
        borderColor,
        borderWidth: 0.5,
        backgroundImage: `linear-gradient(to right, ${fromColor}, ${toColor})`,
        borderStyle: "solid",
        ...(text && { color: "white" }),
        ...buttonStyle,
      }}
      {...props}
    >
      {text ? (
        <span className="text-xs">{text}</span>
      ) : (
        <img src={icon} alt="icon" />
      )}
    </button>
  );

  return tooltipText ? (
    <Tooltip tooltipText={tooltipText} place={tooltipPlace}>
      {button}
    </Tooltip>
  ) : (
    button
  );
};

export default IconButton;
